module.exports = {
      apiKey: "AIzaSyCWAAdvXQmlxFfzRfbqnyLuT8qKKeG1-mc",
      authDomain: "renga-e7b94.firebaseapp.com",
      databaseURL: "https://renga-e7b94.firebaseio.com",
      projectId: "renga-e7b94",
      storageBucket: "",
      messagingSenderId: "59348760519"
    };


// WEBPACK FOOTER //
// ./src/config.js